import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../services/axios';
import { useUserContext } from '../modules/user/UserContext';
import io from 'socket.io-client';
import CircularLoader from '../ui/elements/loader/CircularLoader';

interface CASHandlerProps {
  setLoading: (loading: boolean) => void;
}

const CASHandler: React.FC<CASHandlerProps> = ({ setLoading }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useUserContext();

  useEffect(() => {
    // Remove ticket from URL immediately on component mount
    const params = new URLSearchParams(location.search);
    const ticket = localStorage.getItem('casTicket');
    const username = params.get('username');

    const socket = io(process.env.REACT_APP_BASE_URL || '');
    socket.on('connect', () => {
      console.log('Socket connected:', socket.id);
    });

    socket.on('booking_created', (data) => {
      console.log('Booking created event received:', JSON.stringify(data));
    });

    const validateTicket = async () => {
      setLoading(true);
      try {
        let user;
        let token;

        if (!ticket && username) {
          // Bypass CAS for testing using username from URL
          // console.log('Bypassing CAS for testing with username:', username);
          const response = await axiosInstance.post('/auth/validate-ticket', {
            ticket: 'ST-TEST',
            service: `${window.location.origin}`,
            username,
          });
          token = response.data.token;
          localStorage.setItem('authToken', token);
          const userResponse = await axiosInstance.get('/auth/me');
          user = userResponse.data;
        } else if (ticket) {
          // Standard CAS flow
          const response = await axiosInstance.post('/auth/validate-ticket', {
            ticket,
            service: `${window.location.origin}`,
          });
          token = response.data.token;
            localStorage.setItem('authToken', token);
          const userResponse = await axiosInstance.get('/auth/me');
          user = userResponse.data;
          localStorage.setItem('authToken', token);
          localStorage.setItem('user', JSON.stringify(user));
        } else {
          // No ticket or username — redirect to CAS login
          const serviceUrl = encodeURIComponent(`${window.location.origin}`);
          window.location.replace(`${process.env.REACT_APP_CAS_BASE_URL}/login?service=${serviceUrl}`);
          return;
        }

        // Set user in context
        setUser(user);

        // Notify backend via socket
        socket.emit('user-authenticated', {
          userId: user.id,
          role: user.role.type,
        });

        // Join role-based room
        if (user.role.type.toLowerCase() === 'admin') {
          socket.emit('joinRoom', {
            userId: user.id,
            role: user.role.name,
          });
        } else if (user.role.type.toLowerCase() === 'exhibitor') {
          socket.emit('joinRoom', {
            userId: user.id,
            role: user.role.name,
            exhibitorId: user.exhibitorId || user.exhibitor?.id,
          });
        }

        navigate('/dash');
      } catch (error) {
        console.error('Ticket validation failed:', error);
      } finally {
        setLoading(false);
      }
    };

    validateTicket();

    return () => {
      socket.disconnect();
    };
  }, [location.search, navigate, setUser, setLoading]);

  return <CircularLoader />;
};

export default CASHandler;